{
  "#UTILITIES": {
    "WELCOME": "{{userFullName}}",
    "CHANGE_ACCOUNT": {
      "TITLE": "Switch Company",
      "SUBMIT": "Confirm",
      "SUCCESS_MESSAGE": "Company has been switched",
      "ERROR_MESSAGE": "Failed to switch company"
    },
    "CONTEXT": {
      "TITLE": "Logged in as",
      "SAVE": "Save",
      "SUCCESS": "Context has been changed",
      "NOT_SUPPORTED": "The context cannot be changed with this type of login",
      "NO_COMPONENTS": "No components were set to edit the context",
      "DETAIL_CONTEXT_SETTINGS": "Open more settings..."
    },
    "VKFORG": {
      "LABEL": "Vkforg"
    },
    "FIRMA": {
      "LABEL": "Company"
    },
    "ACCOUNT_CONTEXT": {
      "LABEL": "Company",
      "CHANGE": "Change"
    },
    "USER_CONTEXT": {
      "LABEL": "User"
    },
    "SETTINGS": {
      "TITLE": "Settings",
      "USER_CONTACT": {
        "TITLE": "Contact",
        "SUBMIT": "Save",
        "NO_DEFINITION": "No definition could be found",
        "SUCCESS": "Contact has been updated"
      },
      "CONTEXT": {
        "TITLE": "Context"
      }
    },
    "NOTIFICATIONS": {
      "TITLE": "Notifications",
      "UNREAD": "Unread",
      "ALL": "All",
      "MARK_ALL_AS_READ": "Mark all as read",
      "DELETE": "Delete",
      "MARK_AS_READ": "Read",
      "NO_DATA": "No notifications available"
    }
  },
  "#CONNECTION_SETTINGS": {
    "TITLE": "Connections",
    "SELECTED_CONNECTION": "Selected Connection",
    "NAME": "Name",
    "NAME_OPTIONAL": "(optional)",
    "HOST": "Host",
    "PORT": "Port",
    "BASE_PATH": "Base Path",
    "SELECT": "Select",
    "TEST": "Test",
    "SAVE": "Save",
    "ADD": "Add",
    "EDIT": "Edit",
    "SCAN": "Scan",
    "DELETE": "Delete",
    "DELETE_CONFIRM": "Do you really want to delete this connection?",
    "SAVE_SUCCESS": "Connection has been saved!",
    "CHANGE_SUCCESS": "Connection has been changed!",
    "DELETE_SUCCESS": "Connection has been deleted!",
    "SAVE_FAILURE": "Failed to save the connection!",
    "MESSAGES": {
      "TEST_SUCCESS": "Connection tested successfully",
      "TEST_FAILURE": {
        "NO_CONNECTION": "Could not connect to the server!",
        "NOT_VALID": "The connection is not valid!",
        "CLIENT": "A client-side network error occurred!",
        "UNKNOWN": "An unexpected error occurred!"
      },
      "NO_CONNECTION": {
        "TITLE": "Warning",
        "MESSAGE": "No connection has been selected yet"
      },
      "SCAN_ERROR": "The scanned code does not contain a valid connection",
      "SCAN_SUCCESS": "Connection has been added!",
      "SCAN_EXISTING": "Connection has been changed!"
    },
    "LINKS": {
      "LOGIN": "<< Back to Login"
    },
    "DIALOGS": {
      "EDIT": "Edit Connection",
      "NEW": "Create Connection"
    }
  }
}
